import { ProductViewConfigurator } from '~/types/configurator';
import canConfiguratorChoices from '~/data/configuratorChoices/canConfiguratorChoices';

let label;
let description;

export default {
    controls: [
        {
            key: 'type',
            keyLabel: 'can type',
            label: 'Tin Can Type',
            choices: [
                {
                    label: (label = 'Beaded'),
                    detailsModalLabel: label,
                    value: 'beaded',
                    description: (description =
                        '4.0625” diameter × 5.5” height<br />' +
                        'Our beaded tin cans hold approximately 8–12 oz of whole coffee beans (fill testing recommended) and stand 5.5” tall.'),
                    detailsModalDescription: description,
                },
                {
                    label: (label = 'Straight'),
                    detailsModalLabel: label,
                    value: 'straight',
                    description: (description =
                        '4.0625” diameter × 4” height<br />' +
                        '4.0625” diameter × 7” height<br />' +
                        'Our straight tin cans hold between 6–16 oz of coffee — and are available in two sizes, standing either 4″ or 7″ tall (fill testing recommended).'),
                    detailsModalDescription: description,
                },
            ],
            detailsModalLabel: 'Tin can type options:',
        },
        {
            key: 'printStyle',
            keyLabel: 'can print style',
            label: 'Print Style',
            choices: [
                {
                    label: (label = 'Printed'),
                    detailsModalLabel: label,
                    value: 'printed',
                    description: (description =
                        'Cost: $$$$<br />' +
                        'Our digitally printed tin cans are exactly that. We digitally print directly on the metal, allowing your art to have metallic effects, or can be blocked out by a layer of white ink.'),
                    detailsModalDescription: description,
                },
                {
                    label: (label = 'Labeled'),
                    detailsModalLabel: label,
                    value: 'labeled',
                    description: (description =
                        'Cost: $$<br />' +
                        'Labels are available in either a gloss or matte finish, on a white or metallic label material. The printed label is then applied onto either a beaded or straight tin can.'),
                    detailsModalDescription: description,
                },
            ],
            detailsModalLabel: 'Print style options:',
        },
        {
            key: 'labelMaterial',
            keyLabel: 'label material',
            label: 'Label Material',
            choices: [
                {
                    label: (label = 'White'),
                    detailsModalLabel: label,
                    value: 'white',
                    description: (description =
                        'A traditional bright white material that lets your colors pop and your brand shine. Offered with a matte or gloss finish.'),
                    detailsModalDescription: description,
                },
                {
                    label: (label = 'Metallic'),
                    detailsModalLabel: label,
                    value: 'metallic',
                    description: (description =
                        'Prefer the look of the metal can? This material will allow those metallic effects to come through. You can block out areas of metallic effect by layering white ink, feeding 2 birds with 1 scone one might say.'),
                    detailsModalDescription: description,
                },
            ],
            detailsModalLabel: 'Label material options:',
        },
        {
            key: 'finish',
            keyLabel: 'finish',
            label: 'Finish',
            choices: [
                {
                    label: (label = 'Matte'),
                    detailsModalLabel: label,
                    value: 'matte',
                    description: (description =
                        'If you prefer a more satin finish with a softer touch, we suggest matte. A more sophisticated look for your brand.'),
                    detailsModalDescription: description,
                },
                {
                    label: (label = 'Gloss'),
                    detailsModalLabel: label,
                    value: 'gloss',
                    description: (description =
                        'Gloss is a bright, shiny finish for an extra boost to make your colors really pop.'),
                    detailsModalDescription: description,
                },
            ],
            detailsModalLabel: 'Finish options:',
        },
        canConfiguratorChoices.size,
    ],
} as ProductViewConfigurator;
